import {
  Investment,
  InvestmentPerformance,
  RealizedGainByBooking,
} from "@rentablo/api/apiv1";

export type GainLossValues = ReturnType<typeof extractGainLossValues>;

// In "original" mode we want the investment's native currency, so we pick the
// non-suffixed fields. In any other mode the API was called with
// `displayCurrency = globalCurrency` and the *AC fields are denominated in
// that display currency — that's what we want to show.
export const extractGainLossValues = (
  isOriginal: boolean,
  investment: Investment,
  realizedGainByBooking: RealizedGainByBooking,
  investmentPerformance: InvestmentPerformance
) => {
  if (isOriginal) {
    return {
      purchasePrice: investment.purchasePrice || 0,
      purchaseValue: investment.purchaseValue || 0,
      currentMarketValue: investment.currentMarketValue || 0,
      returnOnInvestment: investment.returnOnInvestment || 0,
      returnOnInvestmentInPercent: investment.returnOnInvestmentInPercent || 0,
      netTotalGain: realizedGainByBooking.accumulatedGain?.netGain || 0,
      grossTradingGain:
        realizedGainByBooking.accumulatedTradingGain?.grossGain || 0,
      grossDividendGain:
        realizedGainByBooking.accumulatedDividendGain?.grossGain || 0,
      commission: -1 * (realizedGainByBooking.accumulatedGain?.commission || 0),
      taxAmount: -1 * (realizedGainByBooking.accumulatedGain?.taxAmount || 0),
      performance: investmentPerformance.inInvestmentCurrency,
      showIrr:
        (investmentPerformance.holdingTimeInYears || 0) >= 1 &&
        investmentPerformance.inInvestmentCurrency?.irr,
    };
  }
  return {
    purchasePrice: investment.purchasePriceAC || 0,
    purchaseValue: investment.purchaseValueAC || 0,
    currentMarketValue: investment.currentMarketValueAC || 0,
    returnOnInvestment: investment.returnOnInvestmentAC || 0,
    returnOnInvestmentInPercent: investment.returnOnInvestmentInPercentAC || 0,
    netTotalGain: realizedGainByBooking.accumulatedGain?.netGainAC || 0,
    grossTradingGain:
      realizedGainByBooking.accumulatedTradingGain?.grossGainAC || 0,
    grossDividendGain:
      realizedGainByBooking.accumulatedDividendGain?.grossGainAC || 0,
    commission: -1 * (realizedGainByBooking.accumulatedGain?.commissionAC || 0),
    taxAmount: -1 * (realizedGainByBooking.accumulatedGain?.taxAmountAC || 0),
    performance: investmentPerformance.inAccountCurrency,
    showIrr:
      (investmentPerformance.holdingTimeInYears || 0) >= 1 &&
      investmentPerformance.inAccountCurrency?.irr,
  };
};
